import React from "react";
import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import LoadingWrapper from "../../common/components/elements/LoadingWrapper";
import getBsddsFromIntervention from "../graphql/queries/getBsddsFromIntervention.graphql";
import BsddList from "../../shipping/components/BsddList";

BsddInterventionInformation.propTypes = {
  interventionUuid: PropTypes.string.isRequired,
};

export default function BsddInterventionInformation({ interventionUuid }) {
  const { loading, error, data } = useQuery(getBsddsFromIntervention, {
    variables: {
      interventionUuid,
    },
  });

  return (
    <LoadingWrapper loading={loading} error={Boolean(error)}>
      {() => {
        const bsddsIntervention = data.getBsddsFromIntervention;

        return (
          <div className="mt-3">
            <BsddList
              bsdds={bsddsIntervention ? bsddsIntervention : []}
              showTrackdechetsSynced={true}
              trackdechetsSynced={bsddsIntervention.length > 0}
            />
          </div>
        );
      }}
    </LoadingWrapper>
  );
}
